export default {"src":"/_next/static/media/chevron-right-circle.6f8c4a5a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};